<template>
  <div></div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('system', ['routerStatusRedirect']),
  },
  async created() {
    console.log(`status check ${this.resultName}`)

    const result = await this.getAgreementStatus()
    if (result === false && this.$route?.meta?.requireSignin !== false) {
      const path = '/signup/agreements/nice'
      if (this.$route.path !== path && this.routerStatusRedirect) {
        this.$router.replace(path)
      }
      return
    }
    this.$emit('emitNext', {
      name: this.resultName,
      result,
    })
  },
  methods: {
    ...mapActions('agreement', ['getAgreementStatus']),
  },
}
</script>

<style></style>
